import pxToRem from "theme/base/pxToRem";
import { BordersRoot } from "theme/types/base/borders";

const borders: BordersRoot = {
  borderWidth: {
    0: 0,
    0.5: pxToRem(10.5),
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs_1: pxToRem(1.6),
    sm_2: pxToRem(2),
    md_4: pxToRem(4),
    lg_8: pxToRem(8),
    xl_12: pxToRem(12),
    xxl_16: pxToRem(16),
    section_160: pxToRem(160),
  },
};

export default borders;
